<template>
    <div>
        <el-row :gutter="10">
            <el-col class='header-left' :span='8'>
                <h4>CottonGame</h4>
            </el-col>
            <el-col class='header-right' :span='16'>
                <ul>
                    <!--<li v-for='(item, index) in customerList'>-->
                    <!--    <a :href='`https://wpa.qq.com/msgrd?v=3&uin=${item.account}&site=qq&menu=yes&jumpflag=1`'-->
                    <!--       target='_blank'>客服QQ: {{ item.account }}</a>-->
                    <!--</li>-->
                    <li>
                        <a href='mailto:contact@cottongame.com' target='_blank'>邮箱: contact@cottongame.com</a>
                    </li>
                </ul>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import { customerApi } from '@/service/api/customerApi';

export default defineComponent({
    name: 'CottonHeader',
    data() {
        return {
            customerList: []
        }
    },
    created() {
        this.getList()
    },
    methods: {
        getList() {
            customerApi.getCustomer({account: ""}).then(result => {
                if (result.code === 200) {
                    this.customerList = result.data.records
                }
            })
        }
    }
});
</script>

<style scoped lang='css'>
.header-right ul {
    width: 100%;
    text-align: right;
}

.header-right li {
    display: inline-block;
    margin-left: 1rem;
}

.header-right li a {
    color: #fff;
}
</style>
